import React, { Component } from "react";
import Select from "react-select";
import Switch from "@material-ui/core/Switch";

// ESTILOS CSS PARA LOS INPUTS IMPORTADOS
const colourStyles = {
  input: (styles) => ({
    ...styles,
    color: "#fff",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#fff",
  }),
  control: (styles) => ({
    ...styles,
    backgroundColor: "#696969",
    color: "#fff",
  }),
  placeholder: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  dropdownIndicator: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  noOptionsMessage: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
      backgroundColor: "#000",
    };
  },
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#1c4d85" : isFocused ? "#1978E2" : "#000",
      color: "#FFF",
      cursor: isDisabled ? "not-allowed" : "default",
      "&:hover": {
        backgroundColor: "#1978E2",
      },
    };
  },
};

class GeneralImportTypeForm extends Component {
  render() {
    return (
      <>
        <div className={this.props.workingModal ? "" : "hide"}>
          <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
            CARGANDO INFORMACIÓN
          </div>
        </div>

        <div className={this.props.workingModal ? "hide" : ""}>
          <fieldset className="col-md-12">
            <legend>DATOS DE IMPORTACIÓN</legend>

            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="tipo">
                    Tipo: <span className="text-danger">*</span>
                  </label>
                  <select
                    value={this.props.state.importacion.tipo}
                    onChange={this.props.handleTipoProductoChange}
                    className="form-control"
                    name="tipo"
                    id="tipo"
                  >
                    <option value="" disabled>
                      Seleccione
                    </option>
                    <option value="1">
                      MEDICAMENTOS VETERINARIOS Y PRODUCTOS A FINES
                    </option>
                    <option value="2">
                      PRODUCTOS UTILIZADOS EN ALIMENTACÓN ANIMAL
                    </option>
                  </select>
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="tipo-error"
                  ></div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="guia_area">Guía Aérea:</label>
                  <input
                    type="text"
                    name="guia_area"
                    value={this.props.state.importacion.guia_area}
                    onChange={this.props.handleGuiaAreaChange}
                    className="form-control"
                    id="guia_area"
                    placeholder="Ingrese guía aérea"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="guia_area-error"
                  ></div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="importador">
                    Importador: <span className="text-danger"> *</span>
                  </label>
                  <Select
                    id="importador"
                    name="importador"
                    styles={colourStyles}
                    placeholder="Seleccione"
                    isClearable={false}
                    value={
                      this.props.state.importador !== null
                        ? this.props.state.importador
                        : { label: "Seleccione", key: "0" }
                    }
                    theme="neutral40"
                    onChange={this.props.handleImportadorSelectChange}
                    options={this.props.state.cat_importadores}
                    getOptionLabel={(importador) => importador.razon_social}
                    getOptionValue={(importador) => importador.id}
                    noOptionsMessage={() => "No se encontraron importadores"}
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="importador-error"
                  ></div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="fabricante">Fabricante:</label>
                  <div className="form-control">
                    {this.props.state.importacion.fabricante ?? "N/A"}
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="pais_origen">
                    País de origen: <span className="text-danger"> *</span>
                  </label>
                  <Select
                    id="pais_origen"
                    name="pais_origen"
                    styles={colourStyles}
                    placeholder="Seleccione"
                    isClearable={false}
                    theme="neutral40"
                    onChange={this.props.handlePaisOrigenChange}
                    options={this.props.state.cat_paises}
                    getOptionLabel={(pais) =>
                      pais.descripcion ? pais.descripcion.toUpperCase() : null
                    }
                    getOptionValue={(pais) => pais.id}
                    noOptionsMessage={() => "No se encontraron países"}
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="pais_origen-error"
                  ></div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group">
                  <label htmlFor="no_factura">
                    No. Factura: <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={this.props.state.importacion.no_factura}
                    onChange={this.props.handleImportacionDataChange}
                    id="no_factura"
                    name="no_factura"
                    placeholder="Ingrese número de factura"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="no_factura-error"
                  ></div>
                </div>
              </div>
            </div>

            <hr />

            <div className="row">
              <div
                className={
                  this.props.state.producto_registrado
                    ? "col-lg-11"
                    : "col-lg-8"
                }
              >
                <div className="form-group">
                  <label htmlFor="nombre_comercial">
                    Producto: <span className="text-danger"> *</span>
                  </label>
                  {this.props.state.producto_registrado ? (
                    <Select
                      id="nombre_comercial"
                      name="nombre_comercial"
                      styles={colourStyles}
                      placeholder="Seleccione"
                      isClearable={false}
                      theme="neutral40"
                      onChange={this.props.handleProductoSelectChange}
                      value={
                        this.props.state.producto_select !== null
                          ? this.props.state.producto_select
                          : { label: "Seleccione", key: "0" }
                      }
                      options={this.props.state.cat_productos}
                      getOptionLabel={(producto) =>
                        producto.nombre_comercial
                          ? producto.nombre_comercial.toUpperCase()
                          : null
                      }
                      getOptionValue={(producto) => producto.id}
                      noOptionsMessage={() => "No se encontraron productos"}
                    />
                  ) : (
                    <input
                      type="text"
                      className="form-control"
                      value={this.props.state.producto.nombre_comercial}
                      id="nombre_comercial"
                      name="nombre_comercial"
                      onChange={this.props.handleProductoChange}
                      placeholder="Ingrese nombre comercial del producto"
                    />
                  )}
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="nombre_comercial-error"
                  ></div>
                </div>
              </div>
              {!this.props.state.producto_registrado ? (
                <div className="col-lg-3">
                  <div className="form-group">
                    <label htmlFor="cantidad_producto">
                      Cantidad producto: <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={this.props.state.producto.cantidad_producto}
                      id="cantidad_producto"
                      name="cantidad_producto"
                      onChange={this.props.handleProductoChange}
                      placeholder="Ingrese cantidad de producto"
                    />
                    <div
                      className="invalid-feedback"
                      style={{ display: "none" }}
                      id="cantidad_producto-error"
                    ></div>
                  </div>
                </div>
              ) : null}
              <div className="col-lg-1">
                <div className="form-group">
                  <label htmlFor="producto_registrado">Registrado:</label>
                  <br />
                  <Switch
                    className="producto_registrado"
                    checked={this.props.state.producto_registrado}
                    name="producto_registrado"
                    onChange={this.props.handleRegProductoEstatusChange}
                  />
                </div>
              </div>
              {/* <div className="col-lg-3">
                <div className="form-group">
                  <label htmlFor="cantidad_producto">
                    Cantidad producto: <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={this.props.state.producto.cantidad_producto}
                    id="cantidad_producto"
                    name="cantidad_producto"
                    onChange={this.props.handleProductoChange}
                    placeholder="Ingrese cantidad de producto"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="cantidad_producto-error"
                  ></div>
                </div>
              </div> */}
            </div>

            {this.props.state.producto_registrado ? (
              <>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="presentacion">
                        Presentación: <span className="text-danger"> *</span>
                      </label>
                      <Select
                        id="presentacion"
                        styles={colourStyles}
                        placeholder="Seleccione"
                        isClearable={false}
                        theme="neutral40"
                        onChange={this.props.handlePresentacionSelectChange}
                        options={this.props.state.cat_presentacion}
                        getOptionLabel={(presentacion) =>
                          `${presentacion.empaque.toUpperCase()} (${
                            presentacion.cantidad
                          } ${presentacion.unidad_medida})`
                        }
                        value={
                          this.props.state.presentacion !== null
                            ? this.props.state.presentacion
                            : { label: "Seleccione", key: "0" }
                        }
                        getOptionValue={(presentacion) => presentacion.id}
                        noOptionsMessage={() =>
                          "No se encontraron presentaciones"
                        }
                      />
                      <div
                        className="invalid-feedback"
                        style={{ display: "none" }}
                        id="presentacion-error"
                      ></div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="cantidad_producto">
                        Cantidad de producto:{" "}
                        <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={this.props.state.producto.cantidad_producto}
                        id="cantidad_producto"
                        name="cantidad_producto"
                        onChange={this.props.handleProductoChange}
                        placeholder="Ingrese cantidad de producto"
                      />
                      <div
                        className="invalid-feedback"
                        style={{ display: "none" }}
                        id="cantidad_producto-error"
                      ></div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div
                    className={
                      !this.props.state.cat_select ? "col-lg-11" : "col-lg-6"
                    }
                  >
                    <div className="form-group">
                      <label htmlFor="especie">
                        Especie: <span className="text-danger"> *</span>
                      </label>
                      <Select
                        id="especie"
                        styles={colourStyles}
                        placeholder="Seleccione"
                        isClearable={false}
                        theme="neutral40"
                        onChange={this.props.handleEspecieSelectChange}
                        options={this.props.state.cat_especies_reg}
                        getOptionLabel={(especie) =>
                          especie.descripcion.toUpperCase()
                        }
                        value={
                          this.props.state.especie !== null
                            ? this.props.state.especie
                            : { label: "Seleccione", key: "0" }
                        }
                        getOptionValue={(especie) => especie.id}
                        noOptionsMessage={() => "No se encontraron especies"}
                      />
                      <div
                        className="invalid-feedback"
                        style={{ display: "none" }}
                        id="especie-error"
                      ></div>
                    </div>
                  </div>
                  {this.props.state.cat_select ? (
                    <div className="col-lg-5">
                      <div className="form-group">
                        <label htmlFor="categoria">
                          Categoría: <span className="text-danger"> *</span>
                        </label>
                        <Select
                          id="categoria"
                          styles={colourStyles}
                          placeholder="Seleccione"
                          isClearable={false}
                          theme="neutral40"
                          onChange={this.props.handleCategoriaSelectChange}
                          options={this.props.state.cat_categorias}
                          getOptionLabel={(categoria) =>
                            categoria.descripcion.toUpperCase()
                          }
                          value={
                            this.props.state.categoria !== null
                              ? this.props.state.categoria
                              : { label: "Seleccione", key: "0" }
                          }
                          getOptionValue={(categoria) => categoria.id}
                          noOptionsMessage={() =>
                            "No se encontraron categorías"
                          }
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="categoria-error"
                        ></div>
                      </div>
                    </div>
                  ) : null}
                  <div className="col-lg-1">
                    <div className="form-group">
                      <label htmlFor="addBtn"></label>
                      <button
                        type="button"
                        onClick={this.props.addProduct}
                        className="btn btn-blue btn-block form-control"
                      >
                        <i className="fa fa-plus"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="row">
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label htmlFor="pais_origen">
                        Empaque: <span className="text-danger"> *</span>
                      </label>
                      <Select
                        id="empaque"
                        styles={colourStyles}
                        placeholder="Seleccione"
                        isClearable={false}
                        theme="neutral40"
                        options={this.props.state.cat_empaques}
                        onChange={this.props.handleEmpaqueChange}
                        getOptionLabel={(empaque) =>
                          empaque.descripcion
                            ? empaque.descripcion.toUpperCase()
                            : null
                        }
                        value={
                          this.props.state.empaque !== null
                            ? this.props.state.empaque
                            : { label: "Seleccione", key: "0" }
                        }
                        getOptionValue={(empaque) => empaque.id}
                        noOptionsMessage={() => "No se encontraron empaques"}
                      />
                      <div
                        className="invalid-feedback"
                        style={{ display: "none" }}
                        id="empaque-error"
                      ></div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label htmlFor="cantidad_empaque">
                        Cantidad: <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="cantidad_empaque"
                        onChange={this.props.handleProductoChange}
                        value={this.props.state.producto.cantidad_empaque}
                        name="cantidad_empaque"
                        placeholder="Ingrese cantidad"
                      />
                      <div
                        className="invalid-feedback"
                        style={{ display: "none" }}
                        id="cantidad_empaque-error"
                      ></div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label htmlFor="unidad_medida">
                        Unidad de medida:{" "}
                        <span className="text-danger"> *</span>
                      </label>
                      <Select
                        id="unidad_medida"
                        styles={colourStyles}
                        placeholder="Seleccione"
                        isClearable={false}
                        theme="neutral40"
                        onChange={this.props.handleUnidadMedidaChange}
                        options={this.props.state.cat_unidad_medidas}
                        getOptionLabel={(unidad_medida) =>
                          unidad_medida.descripcion
                        }
                        value={
                          this.props.state.unidad_medida !== null
                            ? this.props.state.unidad_medida
                            : { label: "Seleccione", key: "0" }
                        }
                        getOptionValue={(unidad_medida) => unidad_medida.id}
                        noOptionsMessage={() =>
                          "No se encontraron unidades de medida"
                        }
                      />
                      <div
                        className="invalid-feedback"
                        style={{ display: "none" }}
                        id="unidad_medida-error"
                      ></div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div
                    className={
                      !this.props.state.cat_select ? "col-lg-11" : "col-lg-6"
                    }
                  >
                    <div className="form-group">
                      <label htmlFor="especie">
                        Especie: <span className="text-danger"> *</span>
                      </label>
                      <Select
                        id="especie"
                        styles={colourStyles}
                        placeholder="Seleccione"
                        isClearable={false}
                        theme="neutral40"
                        onChange={this.props.handleEspecieSelectChange}
                        options={this.props.state.cat_especies}
                        getOptionLabel={(especie) =>
                          especie.descripcion.toUpperCase()
                        }
                        value={
                          this.props.state.especie !== null
                            ? this.props.state.especie
                            : { label: "Seleccione", key: "0" }
                        }
                        getOptionValue={(especie) => especie.id}
                        noOptionsMessage={() => "No se encontraron especies"}
                      />
                      <div
                        className="invalid-feedback"
                        style={{ display: "none" }}
                        id="especie-error"
                      ></div>
                    </div>
                  </div>
                  {this.props.state.cat_select ? (
                    <div className="col-lg-5">
                      <div className="form-group">
                        <label htmlFor="categoria">
                          Categoría: <span className="text-danger"> *</span>
                        </label>
                        <Select
                          id="categoria"
                          styles={colourStyles}
                          placeholder="Seleccione"
                          isClearable={false}
                          theme="neutral40"
                          onChange={this.props.handleCategoriaSelectChange}
                          options={this.props.state.cat_categorias}
                          getOptionLabel={(categoria) =>
                            categoria.descripcion.toUpperCase()
                          }
                          value={
                            this.props.state.categoria !== null
                              ? this.props.state.categoria
                              : { label: "Seleccione", key: "0" }
                          }
                          getOptionValue={(categoria) => categoria.id}
                          noOptionsMessage={() =>
                            "No se encontraron categorías"
                          }
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="categoria-error"
                        ></div>
                      </div>
                    </div>
                  ) : null}
                  <div className="col-lg-1">
                    <div className="form-group">
                      <label htmlFor="addBtn"></label>
                      <button
                        type="button"
                        onClick={this.props.addProduct}
                        className="btn btn-blue btn-block form-control"
                      >
                        <i className="fa fa-plus"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </>
            )}

            <div className="row mt-3">
              <div className="col-lg-12">
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Nombre comercial</th>
                      <th className="text-center">Presentación</th>
                      <th className="text-center">Especie</th>
                      <th className="text-center">Categoría</th>
                      <th className="text-center">Cantidad</th>
                      <th className="text-center"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.state.importacion.productos.length > 0 ? (
                      this.props.state.importacion.productos.map((p, i) => (
                        <tr key={i}>
                          <td className="text-center">{p.nombre_comercial}</td>
                          <td className="text-center">{`${p.empaque_texto} (${p.cantidad_empaque} ${p.unidad_medida_texto})`}</td>
                          <td className="text-center">
                            {p.especie_texto ? p.especie_texto : "N/A"}
                          </td>
                          <td className="text-center">
                            {p.categoria_texto ? p.categoria_texto : "N/A"}
                          </td>
                          <td className="text-center">{p.cantidad_producto}</td>
                          <td className="text-center">
                            <button
                              id={i}
                              type="button"
                              className="btn btn-danger"
                              onClick={this.props.removeProduct}
                            >
                              <i id={i} className="fas fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="text-center" colSpan="6">
                          Sin productos añadidos
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <br />

            <hr />

            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <label htmlFor="pais_procedencia">
                    País de procedencia: <span className="text-danger"> *</span>
                  </label>
                  <Select
                    id="pais_procedencia"
                    styles={colourStyles}
                    placeholder="Seleccione"
                    isClearable={false}
                    theme="neutral40"
                    options={this.props.state.cat_paises}
                    onChange={this.props.handlePaisProcedenciaChange}
                    getOptionLabel={(pais) =>
                      pais.descripcion ? pais.descripcion.toUpperCase() : null
                    }
                    getOptionValue={(pais) => pais.id}
                    noOptionsMessage={() => "No se encontraron países"}
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="pais_procedencia-error"
                  ></div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <label htmlFor="nombre_solicita">
                    Solicitado por: <span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="nombre_solicita"
                    onChange={this.props.handleImportacionDataChange}
                    value={this.props.state.importacion.nombre_solicita}
                    name="nombre_solicita"
                    placeholder="Ingrese nombre del solicitante"
                  />
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="nombre_solicita-error"
                  ></div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <label htmlFor="peticion">
                    Petición: <span className="text-danger"> *</span>
                  </label>
                  <textarea
                    id="peticion"
                    name="peticion"
                    value={this.props.state.importacion.peticion}
                    onChange={this.props.handleImportacionDataChange}
                    placeholder="Ingrese petición"
                    className="form-control"
                  ></textarea>
                  <div
                    className="invalid-feedback"
                    style={{ display: "none" }}
                    id="peticion-error"
                  ></div>
                </div>
              </div>
            </div>

            <hr />

            <button
              type="button"
              onClick={this.props.handleModalFormCloseBtn}
              className="btn btn-danger pull-left"
            >
              Regresar
            </button>

            <button type="submit" className="btn btn-success pull-right">
              Guardar
            </button>

            {/* </div> */}
          </fieldset>
        </div>
      </>
    );
  }
}

export default GeneralImportTypeForm;
